import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

type UsePricingProxyProps = {
  leagueAlias: string;
  contestType: string;
  brand: string;
  isOpen: boolean;
};

export const usePricingProxy = ({
  leagueAlias,
  contestType,
  brand,
  isOpen,
}: UsePricingProxyProps) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const pricingUrl = `/api/restart/pricing-proxy?leagueAlias=${leagueAlias}&contestType=${contestType}&brand=${brand}`;

  const {
    isLoading: isLoadingQuery,
    error: proxyError,
    isSuccess,
    data: validatedResponse,
  // eslint-disable-next-line local-rules/require-query-stale-time
  } = useQuery({
    queryKey: ['pricing-proxy', leagueAlias, contestType, brand],
    queryFn: async () => {
      setIframeLoaded(false);
      const response = await fetch(pricingUrl);
      if (!response.ok) {
        throw new Error(`Proxy failed with status: ${response.status}`);
      }
      const contentType = response.headers.get('content-type');
      if (!contentType?.includes('text/html')) {
        throw new Error('Proxy returned non-HTML content');
      }
      return response.text();
    },
    enabled: isOpen && !!leagueAlias && !!contestType && !!brand,
  });

  return {
    isLoading: isLoadingQuery,
    error: proxyError,
    isSuccess,
    data: validatedResponse,
    iframeLoaded,
    pricingUrl,
    setIframeLoaded,
  };
};
